<template>
  <div class="c-box">
    <form-wrapper
      ref="form"
      :service="Student"
      :formComponent="InnerForm"
      :form.sync="form"
      :errors.sync="errors"
      :objParams="$route.params.studentId"
    />
    <a-divider />
    <div class="actions" v-if="form.id">
      <a-row type="flex" :gutter="16">
        <a-col>
          <a-button v-if="form.id" type="danger" @click="deleteConfirm">
            Usuń konto
          </a-button>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import { Student } from '@/api'
import InnerForm from '@/components/forms/StudentForm'

export default {
  data() {
    return {
      InnerForm,
      Student,
      form: {},
      errors: {}
    }
  },
  methods: {
    deleteConfirm() {
      this.$confirm({
        title: 'Usunięcie kursanta',
        maskClosable: true,
        content: 'Wszystkie dostępności i rezerwacje powiązane z kursantem.',
        okText: 'Kontynuuj',
        cancelText: 'Anuluj',
        onOk: () => {
          this.delete()
        }
      })
    },
    delete() {
      this.loading = true
      Student.delete(this.form.id)
        .then(() => {
          this.$refs.form.isDirty = false
          this.$notification.success({ message: 'Usunięto konto.' })
          this.$router.push('/admin/kursanci')
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
